.cardSkeleton {
  display: flex;
  flex-direction: column;
  gap: var(--ng-gp-16);
  background: rgb(var(--ng-background-0));
  border-radius: var(--ng-rd-12);
  padding: var(--ng-gp-20);
  flex-grow: 1;
  box-shadow: 0 2px 8px rgba(var(--ng-shadow-black-8));
}

.shadowWrapper {
  display: flex;
  flex-direction: column;
  gap: var(--ng-gp-16);
  width: 100%;
  padding: var(--ng-gp-20);
  border-radius: var(--ng-rd-12);
  box-shadow: 0 2px 8px rgba(var(--ng-shadow-black-8));
}

.dashboardSkeleton {
  display: flex;
  gap: var(--ng-gp-20);
  padding: var(--ng-gp-20);
  flex-wrap: wrap;
}

.singleRow {
  width: 100%;
  display: flex;
  gap: var(--ng-gp-16);
}